import GlobalMapSection from "components/pages/GlobalRewards/mapSection";
import { useBricksPreloadedProps } from "hooks/useBrickStaticProps";
import React from "react";
import { types } from "react-bricks/frontend";
import {
  getVerticalPadding,
  VerticalPadding,
  VerticalPaddingWrapper,
  verticalPadSideProp,
} from "../utils/verticalPadding";
import styled from "styled-components";
import { backgroundColorProp } from "../utils/backgroundColor";

interface GlobalRewardsMapProps {
  paddingVertical: VerticalPadding;
  backgroundColor: types.IColor;
}

const GlobalRewardsMap: types.Brick<GlobalRewardsMapProps> = ({
  paddingVertical,
  backgroundColor,
}) => {
  const { rewardProps } = useBricksPreloadedProps();
  return (
    <VerticalPaddingWrapper
      paddingVertical={paddingVertical}
      backgroundColor={backgroundColor?.color}
    >
      <GlobalMapSection
        rewardRegion={rewardProps?.rewardRegion}
        rewardCountries={rewardProps?.rewardCountries || []}
        initialRewards={rewardProps?.initialRewards || []}
        title={null}
        copy={null}
        pb="0"
        pt="0"
      />
    </VerticalPaddingWrapper>
  );
};

GlobalRewardsMap.schema = {
  // Unique brick name
  name: "global-rewards-map",
  label: "Rewards Map",

  // Defaults when a new brick is added
  getDefaultProps: () => ({}),

  // Sidebar Edit controls for props
  sideEditProps: [verticalPadSideProp, backgroundColorProp],

  previewImageUrl: "/static/bricks/global-rewards-map.png",
};

export default GlobalRewardsMap;
